import React, {Component} from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine,
} from 'recharts';
import {colors} from '../../../../../common/constants/colors';
import CustomTooltip from './tooltip/index';

class LineChartInBudgetsAndSales extends Component {
  renderSaleLine() {
    if (!this.props.showSalesData) {
      return null;
    }
    return <Line type='monotone' dataKey='Ventas' stroke={colors[0]} />;
  }

  renderBudgetLine() {
    if (!this.props.showBudgetData) {
      return null;
    }
    return <Line type='monotone' dataKey='Presupuesto' stroke={colors[1]} />;
  }

  render() {
    const {data} = this.props;
    return (
      <ResponsiveContainer width='100%' height={300}>
        <LineChart
          data={data}
          margin={{'top': 30, 'right': 20, 'left': 5, 'bottom': 5}}
        >
          <XAxis dataKey='name' />
          <YAxis />
          <CartesianGrid strokeDasharray='3 3' />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <ReferenceLine x='Diciembre' stroke='red' />

          {this.renderBudgetLine()}
          {this.renderSaleLine()}
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default LineChartInBudgetsAndSales;
